import { theme } from '@theme';
import { Column } from 'react-table';
import { PortfolioResource } from '../../../../../types/PortfolioResource';
import { Typography } from '../../../../style';
import BpsHeader from './BpsHeader';

export const cashDealsColumns: Column<PortfolioResource>[] = [
  {
    Header: <BpsHeader iconSize={28} iconType='score-incentives' toolTipText='Incentives' />,
    id: 'incentives',
    width: 10,
    minWidth: 10,
    Cell: ({ row: { original } }) => (
      <Typography size={theme.typography.h5} fontWeight={theme.typography.fontWeights.normal}>
        {original.replacementDeal.bps_IncentivePercentage}
      </Typography>
    ),
    sortAccessor: 'incentives',
    isSortable: true,
  },
  {
    Header: <BpsHeader iconSize={28} iconType='score-product' toolTipText='Product' />,
    id: 'product',
    width: 10,
    minWidth: 10,
    Cell: ({ row: { original } }) => (
      <Typography size={theme.typography.h5} fontWeight={theme.typography.fontWeights.normal}>
        {original.replacementDeal.bps_ProductPercentage}
      </Typography>
    ),
    sortAccessor: 'product',
    isSortable: true,
  },
  {
    Header: <BpsHeader iconSize={28} iconType='score-warranty' toolTipText='Warranty' />,
    id: 'warranty',
    width: 10,
    minWidth: 10,
    Cell: ({ row: { original } }) => (
      <Typography size={theme.typography.h5} fontWeight={theme.typography.fontWeights.normal}>
        {original.replacementDeal.bps_WarrantyPercentage}
      </Typography>
    ),
    sortAccessor: 'warranty',
    isSortable: true,
  },
  {
    Header: <BpsHeader iconSize={28} iconType='score-ownership' toolTipText='Ownership' />,
    id: 'ownership',
    width: 10,
    minWidth: 10,
    Cell: ({ row: { original } }) => (
      <Typography size={theme.typography.h5} fontWeight={theme.typography.fontWeights.normal}>
        {original.replacementDeal.bps_OwnershipPercentage}
      </Typography>
    ),
    sortAccessor: 'ownership',
    isSortable: true,
  },
  {
    Header: <BpsHeader iconSize={28} iconType='ev-leaf' toolTipText='EV' />,
    id: 'ev',
    width: 10,
    minWidth: 10,
    Cell: ({ row: { original } }) => (
      <Typography size={theme.typography.h5} fontWeight={theme.typography.fontWeights.normal}>
        {getScoreValue(original.closedDeal.evPropensityScore)}
      </Typography>
    ),
    sortAccessor: 'ev',
    isSortable: true,
  },
];

export function getScoreValue(score) {
  if (score > 0 && score <= 30) {
    return 28;
  } else if (score >= 31 && score <= 50) {
    return 38;
  } else if (score >= 51 && score <= 80) {
    return 68;
  } else if (score >= 81 && score <= 100) {
    return 91;
  } else {
    return 0;
  }
}
